<template>
  <mcs-card
    :transparent="transparent"
    :title="title"
    :subtitle="subtitle"
    :titleSizeClass="titleSizeClass"
    :paddingClass="paddingClass"
    :border-color="borderColor"
    :force-row-flex="forceRowFlex"
    @click="$emit('click', $event)"
  >
    <template #header>
      <slot name="header"></slot>
      <v-sheet
        v-if="!thumbnail && url"
        :class="[transparent ? '' : imageBackgroundColor, 'pa-2', 'mb-4']"
      >
        <slot name="image"></slot>
        <v-img
          :width="imgWidth"
          :height="imgHeight"
          :max-width="imgMaxWidth"
          :max-height="imgMaxHeight"
          :contain="imgContain"
          :class="imgRounded ? 'rounded-xl' : ''"
          :src="url"
        />
      </v-sheet>
    </template>
    <template #prepend>
      <v-sheet
        v-if="thumbnail && url"
        :class="[transparent ? '' : imageBackgroundColor, 'pa-2', 'mr-4']"
      >
        <v-img
          :width="imgWidth"
          :height="imgHeight"
          :max-width="imgMaxWidth"
          :max-height="imgMaxHeight"
          :contain="imgContain"
          :class="imgRounded ? 'rounded-xl' : ''"
          rounded
          :src="url"
        />
      </v-sheet>
    </template>

    <slot></slot>
    <template #actions>
      <slot name="actions"></slot>
    </template>
    <template #append>
      <slot name="append"></slot>
    </template>
    <template #title>
      <slot name="title"></slot>
    </template>
  </mcs-card>
</template>

<script>
export default {
  name: 'McsImageCard',

  props: {
    title: { type: String, default: '' },
    subtitle: { type: String, default: '' },
    url: { type: String, default: '' },
    imgWidth: { type: String, default: '' },
    imgHeight: { type: String, default: '' },
    imgMaxWidth: { type: String, default: '' },
    imgMaxHeight: { type: String, default: '' },
    imgContain: { type: Boolean, default: false },
    imgRounded: { type: Boolean, default: false },
    transparent: { type: Boolean, default: false },
    imageBackgroundColor: { type: String, default: 'greyLight' },
    thumbnail: { type: Boolean, default: false },
    titleSizeClass: { type: String, default: 'subtitle-1' },
    paddingClass: { type: String, default: 'pa-6' },
    borderColor: { type: String, default: 'grey' },
    forceRowFlex: { type: Boolean, default: false }
  },

  data() {
    return {};
  },

  computed: {}
};
</script>
